module.exports = __webpack_public_path__ + "img/silver.19f375dc.svg";